import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoginScreen } from './components/LoginScreen';
import { AppShell } from './components/layout/AppShell';
import { ApiError } from './lib/api';
import { signOut, useSession } from './lib/session';
import { AchievementsPage } from './pages/AchievementsPage';
import { DailyPage } from './pages/DailyPage';
import { DashboardPage } from './pages/DashboardPage';
import { KnowledgePage } from './pages/KnowledgePage';
import { ProblemsPage } from './pages/ProblemsPage';
import { RoadmapPage } from './pages/RoadmapPage';
import { StatisticsPage } from './pages/StatisticsPage';

export function App() {
  const session = useSession();
  const queryClient = useQueryClient();

  // A rejected token means the backend no longer trusts this session — most
  // likely API_TOKEN was regenerated. Drop it and ask for the password again
  // rather than leaving every page stuck on an error.
  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      const error = event.query.state.error;
      if (error instanceof ApiError && error.isUnauthorized) signOut();
    });
    return unsubscribe;
  }, [queryClient]);

  // Nothing cached from the previous session should outlive a sign-out.
  useEffect(() => {
    if (!session) queryClient.clear();
  }, [session, queryClient]);

  if (!session) return <LoginScreen />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/roadmap" element={<RoadmapPage />} />
        <Route path="/problems" element={<ProblemsPage />} />
        <Route path="/daily" element={<DailyPage />} />
        <Route path="/knowledge" element={<KnowledgePage />} />
        <Route path="/statistics" element={<StatisticsPage />} />
        <Route path="/achievements" element={<AchievementsPage />} />
        <Route
          path="*"
          element={<p className="text-sm text-muted">Ийм хуудас байхгүй байна.</p>}
        />
      </Routes>
    </AppShell>
  );
}
